import React from 'react';
import InpageBase from './InpageBase';

import TInpage from './types/TInpage';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Success = (props: TInpage) => <InpageBase {...props} signal={FeedbackSignals.Success} />;

export default Success;
